// extracted by mini-css-extract-plugin
module.exports = {"paper":"LayerStatisticsContainer_paper__20oI2"};